<template>
  <div id="mainNavbar">
    <div class="mainNavBar">
      <ul>
        <li
          :class="[
            { active: checkActiveMenu(mamu.link) },
            { lockMenu: (mamu.lock && mamu.lock.value) || mamu.canNotAccess },
          ]"
          v-for="(mamu, index) in listMenu"
          :key="index"
        >
          <router-link
            v-if="!(mamu.lock && mamu.lock.value) && !mamu.canNotAccess"
            :to="{ name: mamu.link !== undefined ? mamu.link.name : '', query: SetQueryURL(mamu) }"
          >
            <div>
              <span v-if="mamu.icon" :class="mamu.icon"></span>
              <img v-else width="25px" :src="mamu.img" alt="" />
              {{ $t(mamu.name) }}
            </div>
          </router-link>

          <div v-if="mamu.lock && mamu.lock.value">
            <div class="lockIsMenu">
              <div>
                <i class="fas fa-lock"></i>
                <p>{{ $t(mamu.lock.text) }}</p>
              </div>
            </div>
            <span :class="mamu.icon"></span>
            {{ $t(mamu.name) }}
          </div>

          <div v-if="mamu.canNotAccess && !(mamu.lock && mamu.lock.value)">
            <div class="lockIsMenu">
              <div>
                <i class="icon-lock_user_right"></i>
                <p>{{ $t("limited_User_rights") }}</p>
              </div>
            </div>
            <span :class="mamu.icon"></span>
            {{ $t(mamu.name) }}
          </div>

          <div
            v-if="mamu.dropdown && !(mamu.lock && mamu.lock.value) && !mamu.canNotAccess"
            v-show="!hideDropdown"
            :class="['dropdown', mamu.class]"
          >
            <div
              name="selectDropdown"
              v-for="select in mamu.dropdown"
              v-show="!select.hide"
              :key="select.key"
              :class="{ lockOrCanNotAccessSelectDropdown: (select.lock && select.lock.value) || select.canNotAccess }"
            >
              <router-link
                v-if="!(select.lock && select.lock.value) && !select.canNotAccess"
                :to="{
                  name: select.link !== undefined ? select.link.name : '',
                  query: SetQueryURL(select),
                }"
              >
                <div :class="'selectDropdown ' + select.bg" @click="Hide()">
                  <div>
                    <i :class="select.icon"></i>
                    <a class="nameSelect">{{ $t(select.name) }} </a>
                  </div>
                  <i v-if="select.option" class="fa fa-chevron-right"></i>
                </div>
              </router-link>

              <div v-if="select.lock && select.lock.value" :class="'selectDropdown'">
                <div class="lockOrCanNotAccessSelect">
                  <i class="fas fa-lock"></i>
                  <p>{{ $t(select.lock.text) }}</p>
                </div>
                <div>
                  <i class="fas fa-lock"></i>
                  <a class="nameSelect">{{ $t(select.name) }}</a>
                </div>

                <i v-if="select.option" class="fa fa-chevron-right"></i>
              </div>

              <div v-if="select.canNotAccess && !(select.lock && select.lock.value)" :class="'selectDropdown'">
                <div class="lockOrCanNotAccessSelect">
                  <i class="icon-lock_user_right"></i>
                  <p>{{ $t("limited_User_rights") }}</p>
                </div>
                <div>
                  <i class="icon-lock_user_right"></i>
                  <a class="nameSelect">{{ $t(select.name) }}</a>
                </div>

                <i v-if="select.option" class="fa fa-chevron-right"></i>
              </div>

              <div v-if="!(select.lock && select.lock.value) && !select.canNotAccess" :class="'option ' + select.class">
                <div
                  v-for="option in select.option"
                  :key="option.key"
                  :class="{
                    lockOrCanNotAccessOptionDropdown: (option.lock && option.lock.value) || option.canNotAccess,
                  }"
                >
                  <router-link
                    v-if="!(option.lock && option.lock.value) && !option.canNotAccess"
                    :to="{
                      name: option.link !== undefined ? option.link.name : '',
                      query: SetQueryURL(option),
                    }"
                  >
                    <div :class="'optionDropdown ' + option.bg" @click="Hide()">
                      <a class="nemeOption">{{ $t(option.name) }} </a>
                    </div>
                  </router-link>

                  <div v-if="option.lock && option.lock.value" :class="['optionDropdown']">
                    <div class="lockOrCanNotAccessOption">
                      <i class="fas fa-lock"></i>
                      <p>{{ $t(option.lock.text) }}</p>
                    </div>
                    <div :class="['d-flex align-items-start justify-content-center']">
                      <i class="fas fa-lock mr-2"></i>
                      <p class="nameSelect">{{ $t(option.name) }}</p>
                    </div>

                    <i v-if="option.option" class="fa fa-chevron-right"></i>
                  </div>

                  <div v-if="option.canNotAccess && !(option.lock && option.lock.value)" :class="['optionDropdown']">
                    <div class="lockOrCanNotAccessOption">
                      <i class="icon-lock_user_right"></i>
                      <p>{{ $t("limited_User_rights") }}</p>
                    </div>
                    <div :class="['d-flex align-items-start justify-content-center']">
                      <i class="icon-lock_user_right mr-2"></i>
                      <p class="nameSelect">{{ $t(option.name) }}</p>
                    </div>

                    <i v-if="option.option" class="fa fa-chevron-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { AbilityAction, AbilitySubject, Package, ParamsReloadType } from "@/enums/enums";
import { CheckMerchantPackage, MerchantId } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MainNavbar extends Vue {
  created() {
    this.listMenu = this.SetListMenu();
  }

  private listMenu: Array<any> = [];
  private Emi = 10;
  private hideDropdown = false;

  public SetListMenu() {
    const lislMenu = [
      {
        name: "Menu_Home",
        icon: "",
        img: require("@/assets/img/menubar/ic_home.png"),
        link: { name: "home" },
      },
      {
        name: "Menu_Salary",
        icon: "",
        img: require("@/assets/img/menubar/ic_salary.png"),
        link: { name: "salary" },
        canNotAccess:
          !this.$can(AbilityAction.Access, AbilitySubject.ViewPaySalary) &&
          !this.$can(AbilityAction.Access, AbilitySubject.ViewSummarySalary),
        dropdown: [
          {
            name: "Salary_Pay_Run",
            link: { name: "salary" },
            canNotAccess: !this.$can(AbilityAction.Access, AbilitySubject.ViewPaySalary),
            option: [
              {
                name: "Create_Salary_Pay_Run",
                bg: "bgOption",
                link: { name: "salaryCreate" },
                canNotAccess:
                  CheckMerchantPackage([Package.Free, Package.AFPFree]) ||
                  !this.$can(AbilityAction.Create, AbilitySubject.CreatePaySalary),
              },
              { name: "Menu_Overview", link: { name: "salary" } },
            ],
          },
          {
            name: "Salary_Summary",
            link: { name: "salarySummary" },
            canNotAccess: !this.$can(AbilityAction.Access, AbilitySubject.ViewSummarySalary),
            option: [
              {
                name: "Create_Salary_Summary",
                bg: "bgOption",
                link: { name: "salary", at: "ca" },
                canNotAccess:
                  CheckMerchantPackage([Package.Free, Package.AFPFree]) ||
                  !(
                    this.$can(AbilityAction.Create, AbilitySubject.CreateSummarySalary) &&
                    this.$can(AbilityAction.Update, AbilitySubject.ApproveSummarySalary)
                  ),
              },
              { name: "Menu_Overview", link: { name: "salarySummary" } },
            ],
          },
        ],
      },
      {
        name: "Menu_Employee",
        icon: "",
        img: require("@/assets/img/menubar/ic_employee.png"),
        link: { name: "employee" },
        canNotAccess: !this.$can(AbilityAction.Access, AbilitySubject.ViewEmployee),
      },
      {
        name: "Menu_Department",
        icon: "",
        img: require("@/assets/img/menubar/ic_position.png"),
        link: { name: "department" },
        canNotAccess: !this.$can(AbilityAction.Access, AbilitySubject.ViewDepartment),
      },
      {
        name: "Menu_Revenue_Deduct",
        icon: "",
        img: require("@/assets/img/menubar/ic_revenue.png"),
        link: { name: "revenue" },
        canNotAccess: !this.$can(AbilityAction.Access, AbilitySubject.ViewRevenueDeduct),
      },
      {
        name: "Menu_Setting",
        icon: "",
        img: require("@/assets/img/menubar/ic_setting.png"),
        link: { name: "setting" },
      },
    ];
    return lislMenu;
  }

  public checkActiveMenu(linkName: any) {
    if (linkName && this.$route.matched.length > 0) {
      if (linkName.name == this.$route.matched[0].name) {
        return true;
      } else {
        return false;
      }
    }
  }

  public SetQueryURL(option: any) {
    const query: any = {
      emi: MerchantId().PeakEncryption(),
      reload: ParamsReloadType.Reload,
    };

    if (option.link && option.link.at) {
      query.at = option.link.at;
    }

    return query;
  }

  public Hide() {
    this.hideDropdown = true;
    setTimeout(() => {
      this.hideDropdown = false;
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
#mainNavbar {
  .mainNavBar {
    margin-top: 10px;
    background: white;
    border-radius: 6px;
    @include shadowboxLv2;
  }
  .mainNavBar {
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      li {
        text-align: center;
        width: 100%;
        cursor: pointer;
        transition: all 0.5s ease;
        a {
          text-align: center;
          @include p2;
          color: #515278;
          div {
            padding: 25px 0px;
            span {
              padding-right: 5px;
              color: $green_active;
            }
          }
        }
        &:hover {
          background: #e8e8e8;
          .dropdown {
            visibility: visible;
            opacity: 1;
            transition-delay: 0.3s;
          }
        }
      }
      .active {
        background: #e8e8e8;
      }
      .lockMenu {
        > div:first-child {
          position: relative;
          padding: 25px 0px;
          span {
            padding-right: 5px;
            color: $green_active;
          }
        }
        .lockIsMenu {
          position: absolute;
          background: rgba(255, 255, 255, 0.85);
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          > div {
            display: none;
            color: white;
          }
          i,
          p {
            color: white;
          }
          &:hover {
            background: rgba(26, 26, 26, 0.85);
            > div {
              display: unset;
            }
          }
        }
      }
      &:first-child {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
      &:last-child {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }

  .dropdown {
    position: absolute;
    z-index: 99999;
    min-width: 270px;
    margin-top: -10px;
    background: white;
    border-radius: 6px;
    @include shadowboxLv2;
    visibility: hidden;
    opacity: 0;
    transition:
      visibility 0s linear 0.3s,
      opacity 0.3s linear;
    hr {
      width: 90%;
      margin: 0px auto 10px auto;
    }
    .head {
      padding: 15px 0px;
    }
    div[name="selectDropdown"] {
      &:hover {
        .option {
          visibility: visible;
          opacity: 1;
          transition-delay: 0s;
        }
        .selectDropdown {
          background: $gray_hover;
          .nameSelect,
          i {
            color: $green_active;
          }
        }
      }
      &:first-child {
        .selectDropdown {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
      }
      &:last-child {
        .selectDropdown {
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
    .selectDropdown {
      text-align: left;
      padding: 12px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > div {
        padding: 0px 0px;
        i {
          font-size: 18px;
          margin-right: 10px;
          color: $green_active;
        }
      }
      a {
        @include font("lig");
      }
      i {
        font-size: 10px;
        color: $text;
      }
      &:hover {
        background: $gray_hover;
        .nameSelect,
        i {
          color: $green_active;
        }
      }
    }
    .lockOrCanNotAccessSelectDropdown {
      > div:first-child {
        position: relative;
      }
      .lockOrCanNotAccessSelect {
        position: absolute;
        background: rgba(255, 255, 255, 0.85);
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        align-items: center;
        padding: 16px;
        i,
        p {
          display: none;
          color: white !important;
        }
        &:hover {
          background: rgba(26, 26, 26, 0.85);
          i,
          p {
            display: unset;
          }
        }
      }
    }
    .option {
      background-color: white;
      position: absolute;
      right: -169px;
      margin-top: -48px;
      border-radius: 6px;
      min-width: 170px;
      border: 0px solid #e8e8e8;
      z-index: 0;
      @include shadowboxLv2;
      visibility: hidden;
      opacity: 0;
      overflow: hidden;
      transition:
        visibility 0s linear 0.3s,
        opacity 0.3s linear;
      .optionDropdown {
        padding: 12px 15px;
        a {
          @include font("lig");
        }
        &:hover {
          background: $gray_hover;
          a {
            color: $green_active;
          }
        }
      }
      .bgOption {
        background: $green_active !important;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        a {
          color: white !important;
        }
        &:hover {
          background: $green !important;
          a {
            color: white !important;
          }
        }
      }
    }
    .lockOrCanNotAccessOptionDropdown {
      > div:first-child {
        position: relative;
      }
      .lockOrCanNotAccessOption {
        position: absolute;
        background: rgba(255, 255, 255, 0.85);
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 16px 0px;
        i,
        p {
          display: none;
          color: white !important;
          margin: 5px;
        }
        &:hover {
          background: rgba(26, 26, 26, 0.85);
          i,
          p {
            display: unset;
          }
        }
      }
    }

    .optionLeft {
      right: 259px;
      min-width: 240px;
    }
    .bgSelect {
      background: $green_active !important;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      a {
        color: white !important;
      }
      &:hover {
        background: $purple_hover !important;
        a {
          color: white !important;
        }
      }
    }
  }
}
.menu-margin {
  margin-left: -50px;
  @media only screen and (max-width: 1552px) {
    margin-left: -48px;
  }
  @media only screen and (max-width: 1280px) {
    margin-left: -63px;
  }
}
.lassMenu-margin {
  margin-left: -50px;
  @media only screen and (max-width: 1824px) {
    right: 0;
    margin-right: 10px;
  }
}
</style>
